<div class="header" id="header" [class.mob-search-active]="isSearchBarShown">
  <div class="head">
    <div class="mobnav_icon" (click)="sharedService.isShowSideNav=!sharedService.isShowSideNav">
      <div class="mobnav_button">
        <div id="mobnav_button_icon" class="mobnav_button-icon">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mob-org-title" [ngClass]="isSearchBarShown ? 'mob-org-title-hide' : ''" (click)="$event.stopPropagation();openDropdown();">{{ isOnAllClients ? 'Practice view' : this.organizationService.selectedOrganizationName }}</div>
    <div id="orgdropdown"
      [ngClass]="isDropdownOpen ? 'dropdown open' : isSearchBarShown ? 'dropdown dropdown-hide' : 'dropdown'"
      (click)="$event.stopPropagation();openDropdown();">
      <span class="arrow" style="cursor: pointer;" *ngIf="organizationList?.length > 1 || practiceOverview">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1.14343L7 8L14 1.14343L12.8335 0L7 5.71475L1.16653 0L0 1.14343Z" fill="#1C1C1C" />
        </svg>
      </span>

      <!-- SD-1248: on the practice's own pages no one client is "the" organisation. -->
      <div class="caption">{{ isOnAllClients ? 'Practice view' : this.organizationService.selectedOrganizationName }}</div>
      <div class="list" *ngIf="organizationList?.length > 1 || practiceOverview" style="z-index:10000">
        <!-- Active org header -->
        <div class="org-list-header" (click)="$event.stopPropagation()">
          <!-- <div class="org-avatar-lg">{{this.organizationService.selectedOrganizationName | shortLogo}}</div> -->
          <span class="org-list-header-name">{{this.organizationService.selectedOrganizationName}}</span>
        </div>

        <div class="search-item" (click)="$event.stopPropagation()">
          <input class="search-input" [ngModel]="searchValue" (ngModelChange)="searchOrganization($event)" />
          <span class="placeholder">
            <img src="../../../assets/img/header/search-icon.svg" alt="">
            <span>Search organizations</span>
          </span>
        </div>

        <div class="no-results" *ngIf="sortedOrganizationList?.length == 0" (click)="$event.stopPropagation()">No Results Found</div>

        <!-- SD-1248: an advisor's way back to every client at once. -->
        <a class="all-clients-row" *ngIf="practiceOverview" routerLink="/clients"
           [class.is-current]="isOnAllClients" (click)="$event.stopPropagation(); isDropdownOpen = false">
          <span class="all-clients-row__icon all-clients-row__icon--logo" aria-hidden="true" *ngIf="practiceOverview.logoUrl">
            <img [src]="practiceOverview.logoUrl" alt="" (error)="practiceOverview.logoUrl = null" />
          </span>
          <span class="all-clients-row__icon" aria-hidden="true" *ngIf="!practiceOverview.logoUrl">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="7" x="3" y="3" rx="1" /><rect width="7" height="7" x="14" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="14" rx="1" /><rect width="7" height="7" x="3" y="14" rx="1" />
            </svg>
          </span>
          <span class="all-clients-row__text">
            <span class="all-clients-row__title">Practice view</span>
            <span class="all-clients-row__sub">
              {{ practiceOverview.clientCount }} {{ practiceOverview.clientCount === 1 ? 'organisation' : 'organisations' }}
              · {{ practiceOverview.needsActionCount }} need action
            </span>
          </span>
          <svg class="all-clients-row__arrow" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
          </svg>
        </a>

        <div class="org-section-label" *ngIf="sortedOrganizationList?.length > 0" (click)="$event.stopPropagation()">ORGANIZATIONS</div>

        <ng-container *ngFor="let org of sortedOrganizationList; let i = index">
          <div
            [ngClass]="this.organizationService.selectedOrganizationName === org.organisationName ? 'item selected' : 'item'"
            (click)="selected(org.organisationID);">
            <div class="org-avatar-sm org-avatar-sm--logo" *ngIf="orgLogo(org) as logo">
              <img [src]="logo" alt="" loading="eager" decoding="async" (error)="dropOrgLogo(org)" />
            </div>
            <div *ngIf="!orgLogo(org)" [class]="'org-avatar-sm sup_img_box_' + ((i % 6) + 1)">{{org.organisationName | shortLogo}}</div>
            <span class="org-name">{{org.organisationName}}</span>
            <svg *ngIf="this.organizationService.selectedOrganizationName === org.organisationName" class="org-check" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8l4 4 6-7" stroke="#FFC93B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
  <!-- SD-1248: Practice view's own pages in the search's place. Search, and + (an expense), are an
       organisation's, and there is no organisation selected here. -->
  <nav class="practice-nav" *ngIf="isOnAllClients" aria-label="Practice view">
    <a class="practice-nav__link" routerLink="/clients" [queryParams]="practiceQuery"
       routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    <!-- SD-1252: client email and the tasks it becomes, across every client. -->
    <a class="practice-nav__link" routerLink="/clients/emails" [queryParams]="practiceQuery"
       routerLinkActive="is-active">Emails</a>
    <a class="practice-nav__link" routerLink="/clients/tasks" [queryParams]="practiceQuery"
       routerLinkActive="is-active">Tasks</a>
    <a class="practice-nav__link" *ngIf="isPracticeManager" routerLink="/clients/team" [queryParams]="practiceQuery"
       routerLinkActive="is-active">Team</a>
    <a class="practice-nav__link" routerLink="/clients/time" [queryParams]="practiceQuery"
       routerLinkActive="is-active">Time</a>
  </nav>
  <div class="search" id="search" *ngIf="!isOnAllClients" appClickOutsideExcept="#header" (clickOutside)="closeSearch()">
    <app-main-search id="searchbar" (showContactForm)="openSearchContact()"
      (openExpense)="openSearchExpense($event)" (openTransaction)="openSearchTransaction($event)"
      *ngIf="isSearchBarShown" style="width: 100%;" (hideSearch)="closeSearch()" (openAiPanel)="openAiPanelWithQuery($event)"></app-main-search>
      <button class="mob-search-close" *ngIf="isSearchBarShown" (click)="clickCloseSearchBarIcon()">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
  </div>

  <div class="sides">
    <!-- Mobile-only search icon: always visible in toolbar -->
    <button class="header-search-btn header-mobile-only" *ngIf="!isOnAllClients" [class.hide]="isSearchBarShown" (click)="isSearchBarShown = true">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="7.5" cy="7.5" r="5" stroke="currentColor" stroke-width="1.6"/>
        <path d="M11.5 11.5L15 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    </button>
    <!-- Notifications: invoice processing errors. Bell sits to the left of the
         "+" button; badge shows how many invoices need attention. -->
    <div class="notif-button" [ngClass]="isMobileDevice && isSearchBarShown ? 'hide-button' : ''">
      <button type="button" class="notif-bell" [matMenuTriggerFor]="notifMenu"
        #notifMenuTrigger="matMenuTrigger" matTooltip="Notifications"
        [matTooltipShowDelay]="showToolTipDelay">
        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        <span class="notif-badge" *ngIf="processingErrorCount > 0">{{ processingErrorCount }}</span>
      </button>

      <mat-menu #notifMenu="matMenu" class="notif-menu" xPosition="before">
        <div class="notif-content" (click)="$event.stopPropagation()">
          <div class="notif-header">
            <span class="notif-title">Notifications</span>
            <span class="notif-count" *ngIf="processingErrorCount > 0">{{ processingErrorCount }}</span>
          </div>

          <!-- Empty state -->
          <div class="notif-empty" *ngIf="processingErrorCount === 0">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#10b981"
              stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <div class="notif-empty-title">You're all caught up</div>
            <div class="notif-empty-sub">No invoice processing errors right now.</div>
          </div>
          <!-- Error list -->
          <div class="notif-list" *ngIf="processingErrorCount > 0">
            <div class="notif-row" *ngFor="let err of processingErrors">
              <div class="notif-row-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div class="notif-row-body">

                <!-- Top row: invoice number (if available) + stage -->
                <div class="notif-row-top">
                  <span class="notif-row-invoice" *ngIf="err.invoiceNumber">
                    #{{ err.invoiceNumber }}
                  </span>
                  <span class="notif-row-invoice notif-row-invoice--none" *ngIf="!err.invoiceNumber">
                    No invoice
                  </span>
                  <span class="notif-row-stage" *ngIf="err.stageOrPlace">{{ err.stageOrPlace }}</span>
                </div>

                <!-- Supplier + amount row (only if at least one is available) -->
                <div class="notif-row-supplier" *ngIf="err.supplierName || err.amount">
                  <span *ngIf="err.supplierName">{{ err.supplierName }}</span>
                  <span *ngIf="err.supplierName && err.amount"> · </span>
                  <span *ngIf="err.amount">{{ err.amount | currency }}</span>
                </div>

                <!-- Fallback: no document info at all -->
                <div class="notif-row-supplier notif-row-supplier--none"
                  *ngIf="!err.supplierName && !err.amount && !err.invoiceNumber">
                  Document could not be processed
                </div>

                <!-- File name fallback if no supplier info but file exists -->
                <div class="notif-row-supplier" *ngIf="!err.supplierName && err.fileName">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:4px;">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                  </svg>
                  {{ err.fileName }}
                </div>

                <!-- Error message -->
                <div class="notif-row-error" *ngIf="err.errorMessage">{{ err.errorMessage }}</div>

                <!-- Footer: time + actions -->
                <div class="notif-row-foot">
                  <span class="notif-row-time" *ngIf="err.date">
                    {{ err.date | date:'MMM d, h:mm a' }}
                  </span>
                  <div class="notif-row-actions">
                    <button type="button" class="notif-icon-btn notif-icon-btn--ghost"
                      (click)="downloadProcessingError(err, $event)" title="Download document"
                      matTooltip="Download document" [matTooltipShowDelay]="showToolTipDelay">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </button>
                    <button type="button" class="notif-icon-btn notif-icon-btn--primary"
                      [disabled]="isResubmitting(err.id)"
                      (click)="resubmitProcessingError(err, $event)"
                      [title]="isResubmitting(err.id) ? 'Resubmitting…' : 'Resubmit'"
                      [matTooltip]="isResubmitting(err.id) ? 'Resubmitting…' : 'Resubmit'"
                      [matTooltipShowDelay]="showToolTipDelay">
                      <svg *ngIf="!isResubmitting(err.id)" width="16" height="16" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                      </svg>
                      <svg *ngIf="isResubmitting(err.id)" class="notif-spinner" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                        <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                      </svg>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </mat-menu>
    </div>

    <!-- + opens the upload panel straight away; coding an expense by hand is offered
         inside it, rather than in a menu first. -->
    <div class="upload-button" *ngIf="!isOnAllClients" [ngClass]="isSearchBarShown ? 'hide-button' : ''">
      <button type="button" class="circle" matTooltip="Add an expense" [matTooltipShowDelay]="400"
        aria-label="Add an expense" (click)="openUploadSidebar()">
        <span>+</span>
      </button>
    </div>

    <!-- help button hidden for now -->
    <!-- <button class="header-help-btn header-desktop-only" (click)="showGuidesModal = true" matTooltip="How-to guides" [matTooltipShowDelay]="showToolTipDelay">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.6"/>
        <path d="M6.5 6.8a2.5 2.5 0 1 1 3.54 2.29A1 1 0 0 0 9 10.05V11.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        <circle cx="9" cy="13.2" r="0.85" fill="currentColor"/>
      </svg>
    </button> -->
    <!-- <button class="header-ai-btn header-desktop-only" (click)="showAiPanel = true" matTooltip="AI Agent" [matTooltipShowDelay]="showToolTipDelay" *ngIf="currentUser?.aiUser || currentUser?.role === 1">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="3.5" y="5.5" width="11" height="8" rx="2" stroke="currentColor" stroke-width="1.5"/>
        <circle cx="6.5" cy="9" r="1" fill="currentColor"/>
        <circle cx="11.5" cy="9" r="1" fill="currentColor"/>
        <line x1="9" y1="5.5" x2="9" y2="3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="9" cy="2.5" r="0.8" fill="currentColor"/>
        <line x1="3.5" y1="9" x2="2" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="14.5" y1="9" x2="16" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button> -->
    <div>
      <div class="user_image" mat-button [matMenuTriggerFor]="menu">
        <span class="user_logo">{{currentUser?.name | shortLogo}}</span>
      </div>
      <mat-menu #menu="matMenu" class="user_menu">
        <!-- Profile header -->
        <div class="um-header" (click)="$event.stopPropagation()">
          <div class="um-avatar">{{currentUser?.name | shortLogo}}</div>
          <div class="um-info">
            <div class="um-name">{{currentUser?.name}}</div>
            <div class="um-role" *ngIf="currentUser?.email">{{currentUser?.email}}</div>
          </div>
        </div>

        <!-- Inbox section -->
        <div class="um-section" *ngIf="personalEmail" (click)="$event.stopPropagation()">
          <div class="um-section-label">My Inbox</div>
          <div class="inbox-row">
            <span class="inbox-pill">
              <span class="inbox-email">{{personalEmail}}</span>
              <button type="button" class="copy-btn" (click)="copyToClipboard(personalEmail, $event)"
                matTooltip="Copy to clipboard" [matTooltipShowDelay]="showToolTipDelay">
                <img src="/assets/images/copy.svg" alt="Copy" />
              </button>
            </span>
            <span class="copied-tooltip" *ngIf="copiedInbox === personalEmail">Copied!</span>
          </div>
        </div>
        <div class="um-section" *ngIf="companyEmail && roleId != '3'" (click)="$event.stopPropagation()">
          <div class="um-section-label">Company Inbox</div>
          <div class="inbox-row">
            <span class="inbox-pill">
              <span class="inbox-email">{{companyEmail}}</span>
              <button type="button" class="copy-btn" (click)="copyToClipboard(companyEmail, $event)"
                matTooltip="Copy to clipboard" [matTooltipShowDelay]="showToolTipDelay">
                <img src="/assets/images/copy.svg" alt="Copy" />
              </button>
            </span>
            <span class="copied-tooltip" *ngIf="copiedInbox === companyEmail">Copied!</span>
          </div>
        </div>

        <!-- SD-1137: Accounting integration status. Loading while the API is
             in flight (avoids flashing "Not connected" during a slow response).
             Once resolved: hidden for "No Accounting" orgs, otherwise shows
             Xero/QBO connection state. -->
        <div class="um-section um-section--accounting"
             *ngIf="accountingLoading || accounting.platform === 'Xero' || accounting.platform === 'QBO'"
             (click)="$event.stopPropagation()">
          <div class="um-section-label">Accounting</div>

          <!-- Loading skeleton -->
          <div class="acct-row acct-row--loading" *ngIf="accountingLoading">
            <span class="acct-row__logo acct-row__skeleton acct-row__skeleton--logo" aria-hidden="true"></span>
            <div class="acct-row__body">
              <div class="acct-row__skeleton acct-row__skeleton--name"></div>
              <div class="acct-row__skeleton acct-row__skeleton--sub"></div>
            </div>
            <span class="acct-row__skeleton acct-row__skeleton--pill" aria-hidden="true"></span>
            <span class="sr-only">Checking accounting connection…</span>
          </div>

          <!-- Connected -->
          <div class="acct-row" *ngIf="!accountingLoading && accounting.connected">
            <img class="acct-row__logo"
                 [src]="accounting.platform === 'QBO' ? '../../../assets/img/QuickBookConnectLogo.png' : '../../../assets/img/Xero.png'"
                 alt="" aria-hidden="true">
            <div class="acct-row__body">
              <div class="acct-row__name">
                {{ accounting.platform === 'QBO' ? 'QuickBooks' : 'Xero' }}
              </div>
              <div class="acct-row__sub" *ngIf="accounting.tenantName">{{ accounting.tenantName }}</div>
            </div>
            <span class="acct-row__pill acct-row__pill--ok">Connected</span>
          </div>

          <!-- Disconnected -->
          <div class="acct-row" *ngIf="!accountingLoading && !accounting.connected">
            <img class="acct-row__logo"
                 [src]="accounting.platform === 'QBO' ? '../../../assets/img/QuickBookConnectLogo.png' : '../../../assets/img/Xero.png'"
                 alt="" aria-hidden="true">
            <div class="acct-row__body">
              <div class="acct-row__name">
                {{ accounting.platform === 'QBO' ? 'QuickBooks' : 'Xero' }}
              </div>
              <div class="acct-row__sub">Not connected — reconnect from Settings.</div>
            </div>
            <span class="acct-row__pill acct-row__pill--off">Off</span>
          </div>
        </div>

        <!-- Menu items -->
        <div class="um-divider"></div>
        <button *ngIf="roleId == '1'" type="button" mat-menu-item class="menu_item" (click)="openAdminPortal()">
          <img src="../../../assets/img/header/help_center.svg" alt="">
          <span>Admin Portal</span>
        </button>
        <button type="button" mat-menu-item class="menu_item" (click)="redirectToHelpCenter()">
          <img src="../../../assets/img/header/help_center.svg" alt="">
          <span>Help Center</span>
        </button>
        <div class="um-divider"></div>
        <button mat-menu-item class="menu_item menu_item--logout" (click)="signOut()">
          <img src="../../../assets/img/header/log_out.svg" alt="">
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>

<!-- ══ HOW-TO GUIDES MODAL ══ -->
<div class="guides-backdrop" *ngIf="showGuidesModal" (click)="showGuidesModal = false; selectedGuide = null"></div>
<div class="guides-modal" *ngIf="showGuidesModal">

  <!-- Header -->
  <div class="gm-header">
    <div class="gm-title">
      <button class="gm-back" *ngIf="selectedGuide" (click)="selectedGuide = null">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        All guides
      </button>
      <ng-container *ngIf="!selectedGuide">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="9" r="8" stroke="#F5C518" stroke-width="1.6"/>
          <path d="M6.5 6.5a2.5 2.5 0 1 1 3.54 2.29A1 1 0 0 0 9 9.75V11" stroke="#F5C518" stroke-width="1.6" stroke-linecap="round"/>
          <circle cx="9" cy="13" r="0.9" fill="#F5C518"/>
        </svg>
        How-to guides
      </ng-container>
    </div>
    <button class="gm-close" (click)="showGuidesModal = false; selectedGuide = null">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- ── LIST VIEW ── -->
  <ng-container *ngIf="!selectedGuide">
    <div class="gm-search-row">
      <div class="gm-search-wrap">
        <svg class="gm-search-ic" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <circle cx="6.5" cy="6.5" r="4.5" stroke="#ADADAD" stroke-width="1.5"/>
          <path d="M10.5 10.5L13 13" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <input class="gm-search" type="text" [(ngModel)]="guidesSearch" placeholder="Search guides…" [ngModelOptions]="{standalone: true}" autofocus>
        <button class="gm-search-clear" *ngIf="guidesSearch" (click)="guidesSearch = ''">×</button>
      </div>
    </div>

    <div class="gm-cats">
      <button class="gm-cat" *ngFor="let c of guideCategories" [class.active]="guidesCategory === c" (click)="guidesCategory = c">{{ c }}</button>
    </div>

    <div class="gm-grid">
      <div *ngIf="filteredGuides.length === 0" class="gm-empty">No guides match "{{ guidesSearch }}"</div>
      <div class="gm-card" *ngFor="let g of filteredGuides" (click)="selectedGuide = g">
        <div class="gm-card-thumb">
          <img [src]="'https://img.youtube.com/vi/' + g.videoId + '/mqdefault.jpg'" [alt]="g.title" loading="lazy">
          <div class="gm-card-play">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="rgba(0,0,0,0.5)"/>
              <path d="M13 10l10 6-10 6V10z" fill="white"/>
            </svg>
          </div>
          <div class="gm-duration">{{ g.duration }}</div>
        </div>
        <div class="gm-card-body">
          <div class="gm-cat-tag">{{ g.category }}</div>
          <div class="gm-card-title">{{ g.title }}</div>
          <div class="gm-card-desc">{{ g.description }}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ── DETAIL VIEW ── -->
  <div class="gm-detail" *ngIf="selectedGuide">
    <div class="gm-video-wrap">
      <iframe [src]="getSafeVideoUrl(selectedGuide.videoId)"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>
    <div class="gm-detail-body">
      <div class="gm-detail-meta">
        <span class="gm-cat-tag">{{ selectedGuide.category }}</span>
        <span class="gm-detail-dur">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <circle cx="6.5" cy="6.5" r="5.5" stroke="#ADADAD" stroke-width="1.3"/>
            <path d="M6.5 3.5v3l2 1.5" stroke="#ADADAD" stroke-width="1.3" stroke-linecap="round"/>
          </svg>
          {{ selectedGuide.duration }}
        </span>
      </div>
      <h2 class="gm-detail-h">{{ selectedGuide.title }}</h2>
      <p class="gm-detail-text">{{ selectedGuide.description }}</p>
      <a class="gm-yt-btn" [href]="'https://www.youtube.com/watch?v=' + selectedGuide.videoId" target="_blank" rel="noopener">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M3 2l10 5.5L3 13V2z" fill="currentColor"/>
        </svg>
        Watch on YouTube
      </a>
    </div>
  </div>

</div>

<app-sidebar [isSidebarVisible]=isSidebarVisible [isSettingsSidebar]=isSettingsSidebar [isUploadSidebar]=isUploadSidebar
  (isClosed)="toggleSidebar($event)">
</app-sidebar>

<div class="supplier-contact-sidenav" [ngClass]="showSupplierBar ? 'cd_sidebar_main sidenav sidenav-show outside_amo_sidebar' : 'sidenav'"
  [class.sidenav--over]="showSupplierBar && supplierPanelOver" (click)="toggleSupplierBar($event)">
  <div class="modal_wrapper_back"></div>
  <div class="sidenav_in cd_sidebar">
    <div class="reports_tab">
      <div class="form-group" (click)="$event.stopPropagation()">
        <app-supplier-contancts *ngIf="showSupplierBar" [billsToPayMode]="false" [supplierTabMode]="true"
          [isEditable]="true" (closeFormEvent)="toggleSupplierBar($event)" [currentPannel]="currentPannel"
          (contactIsSavedEvent)="setContactIsSaved($event)">
        </app-supplier-contancts>
      </div>
    </div>
  </div>
</div>

<!-- A searched expense: the inbox form in a side panel, as the dashboard opens one -->
<div [ngClass]="showSearchExpensePanel ? 'sidenav sidenav-show' : 'sidenav'">
  <div class="sidenav_in cd_sidebar">
    <div class="form-group">
      <app-upload-invoice-form *ngIf="showSearchExpensePanel" [isEditable]="searchExpenseEditable" [billsToPayMode]="false"
        [hexColorClass]="searchExpenseColorClass" [heightDeduct]="81" [isInboxMobileMode]="true"
        [invoiceTaskMode]="true" (closeFormOnBillsToPayEvent)="closeSearchExpense()"
        (invoiceApprovedEvent)="closeSearchExpense()" (closeFormOnDeletePublish)="closeSearchExpense()">
      </app-upload-invoice-form>
    </div>
  </div>
</div>

<!-- A searched transaction: the reconcile panel the Transactions screen uses -->
<app-transaction-detail-panel [open]="showSearchTransactionPanel" (closed)="closeSearchTransaction()">
  <app-activity *ngIf="showSearchTransactionPanel" [isInvoiceMode]="false" [isBankTransMode]="true"
    [bankTransArr]="searchTransactions" [type]="'transaction'"
    (refreshDataOnMatch)="closeSearchTransaction()" (refreshDataOnUnMatch)="closeSearchTransaction()">
  </app-activity>
</app-transaction-detail-panel>


<app-ai-chat-panel [isOpen]="showAiPanel" [initialQuery]="aiPanelInitialQuery" (closed)="showAiPanel = false; aiPanelInitialQuery = '';isSearchBarShown = true;"></app-ai-chat-panel>
